import formula from '@/api/hr/basic-salary-formula'
import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  parameters: []
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  RECEIVE_PARAMETERS(state, data) {
    state.parameters = data
  }
}

export const actions = {
  fetch(context, attributes = {}) {
    const params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search
      },
      attributes
    )
    return formula.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },

  update(context, { id, data }) {
    return formula.update(id, data)
  },

  async getParameter(context) {
    if (!context.state.parameters.length > 0) {
      let response = await formula.getParameter()
      context.commit('RECEIVE_PARAMETERS', response.data)
    }
  }
}
